import React, { useCallback } from 'react';
import copy from 'clipboard-copy';
import {
  BackArrowIcon,
  Dropdiv,
  IconDiv,
  ProjectContent,
  ProjectLinkEmbedContainer,
  ProjectName,
  ProjectProgress,
  ProjectStatusDot,
  ProjectStatusText
} from './style';
import SVGIcon from '../../assets/images/svg/SVGIcon';
import { Dropdown, DropdownItem } from '../Dropdown';
import { PROJECT_STATUS_COLOR } from '../../global/constants';
import { rootStore } from '../../mobx/rootStore';
import { dispatchProjectError, dispatchProjectSuccess } from '../../services/projectServices';
import { useHistory } from 'react-router-dom';

interface ProjectEmbedCardProps {
  node: {
    attribs: {
      url: string;
      projectid: string;
      projectname: string;
      projectstatus: string;
    };
  };
}

const ProjectEmbedCard: React.FC<ProjectEmbedCardProps> = ({ node }: ProjectEmbedCardProps) => {
  const { url, projectid, projectname, projectstatus } = node.attribs;
  // Mobx store variables
  const { projectStore } = rootStore || {};
  const { projects } = projectStore || {};
  const projectDetails = projects?.find((project) => project.id === projectid);
  //Other variables
  const history = useHistory();

  const projectStatusRef = projectDetails?.progressData
    ? projectDetails?.progressData
    : projectstatus
    ? {
        ...JSON.parse(projectstatus),
        status: Number(JSON.parse(projectstatus).status)
      }
    : null;

  const onClickCopyProjectLink = async (url: string) => {
    await copy(url);
    dispatchProjectSuccess('Project url copied successfully!');
  };

  const projectStatusText = projectStatusRef
    ? `${projectStatusRef.statusText} (${projectStatusRef.progress}%)`
    : 'Not Started yet (0%)';
  const projectStatusColor = projectStatusRef?.status
    ? PROJECT_STATUS_COLOR[projectStatusRef.status]
    : 'var(--neutral-primary)';

  const onClickCard = useCallback(() => {
    if (projectDetails) {
      const path = new URL(url).pathname;
      rootStore.projectStore.setCurrentProject(projectid);
      history.push(path);
    } else dispatchProjectError(`You don't have access for this project`);
  }, [history, projectDetails, projectid, url]);

  return (
    <ProjectLinkEmbedContainer onClick={onClickCard}>
      <ProjectContent>
        <ProjectName>
          {projectDetails?.name || projectname || 'Unknown Project'}{' '}
          <BackArrowIcon>
            <SVGIcon
              name='report-right-arrow-icon'
              width='16'
              height='16'
              viewBox='0 0 18 18'
              stroke='var(--text-secondary)'
            />
          </BackArrowIcon>
        </ProjectName>

        <ProjectProgress>
          <ProjectStatusDot $statusColor={projectStatusColor} />
          <ProjectStatusText>{projectStatusText}</ProjectStatusText>
        </ProjectProgress>
      </ProjectContent>
      <Dropdiv>
        <Dropdown
          activeClassName='active-dropdown'
          content={
            <IconDiv>
              <SVGIcon name='task-detail-dot-icon' width='16' height='16' viewBox='0 0 18 18' />
            </IconDiv>
          }
          trigger='click'>
          <DropdownItem
            label='Copy link'
            iconName='copy-link-icon'
            onClick={() => onClickCopyProjectLink(url)}
            iconViewBox='0 0 18 18'
          />
        </Dropdown>
      </Dropdiv>
    </ProjectLinkEmbedContainer>
  );
};

export default ProjectEmbedCard;
